import React from "react";
import OrderForm from "./OrderForm";
import Xhr from "../../../../helpers/Xhr";

class ByPpsForm extends OrderForm {
	static defaultProps = {
		minAmount : 1
	};

	state = {
		selectedCash : null,
		amount       : this.props.minAmount,
		toPay        : this.props.minAmount,
		nalog        : this.props.minAmount * 0.04,
		messages     : ''
	};

	cashes = [
		{
			id      : null,
			city    : null,
			address : null
		},
		{
			id      : 2003,
			city    : "г. Исфара",
			address : "ул.Марказй 17 (ориентир напротив кинотеатра Мубораккадам)"
		},
	];

	changeCash(e) {
		this.setState({
			selectedCash : parseInt(e.target.value)
		});
	}

	onSubmit() {
		const data = {
			amount : this.state.amount,
			cash   : this.state.selectedCash
		};

		if ( !this.hasErrors ) {
			Xhr.cashOut(data).then((resp) => {
				this.setState({
					messages : resp.messages
				});
			});
		}
	}

	render() {
		return (
			<div className="description__order">
				{/*Сумма заказа*/}
				{this.getAmountRow()}

				{/*Сумма к выплате*/}
				{this.getToPayRow()}

				{/*Налог*/}
				{/*{this.getNalogRow()}*/}

				{/*ППС*/}
				{this.getPpsRow()}

				{this.getOrderButton()}

				{this.state.messages !== '' &&
				<div className="description__order-item">
					<div></div>
					<div className="errors">{this.state.messages}</div>
					<div></div>
				</div>}
			</div>
		);
	}
}

export default ByPpsForm;


// WEBPACK FOOTER //
// ./src/app/pages/User/Takemoney/Form/ByPpsForm.js